export default "__VITE_ASSET__CI5UKKZ8__"